<template>
  <dd-header-card
      :wide-content="true"
      :header="category.name"
      :collapsible="true"
      :collapsed="true"
      @collapse="(val) => onCollapsed(val, category)"
      :data-dusk="'attachable-category-' + category.name.toLowerCase().replace(' ', '-')"
  >
    <template v-if="category.attachable_count && category.attachable_count.data.count" #icon>
      <span class="badge">{{ category.attachable_count.data.count }}</span>
    </template>

    <template #action>
      <div class="flex-row align-items-center gap-md">
        <div class="" data-dusk="multiple-attachables-actions">
          <a-dropdown v-if="showMultipleActionButton"
                      class="attachable-selectable-table-row"
                      :trigger="['click']">
            <a-button @click="onMultipleDropdownClick($event)" type="default">
              Acties ({{ selectedFromActiveCategory.length }})
              <a-icon type="down"/>
            </a-button>

            <template #overlay>
              <a-menu>
                <a-menu-item @click="onCopyClick" data-dusk="copy">
                  <content-copy-icon></content-copy-icon>
                  Kopieer naar
                </a-menu-item>
                <a-menu-item @click="onMoveClick" data-dusk="move">
                  <content-cut-icon></content-cut-icon>
                  Verplaats naar
                </a-menu-item>
                <a-menu-item @click="onDownloadClick" data-dusk="download">
                  <download-icon></download-icon>
                  Downloaden
                </a-menu-item>
                <a-menu-item @click="onDeleteClick" data-dusk="delete">
                  <delete-icon></delete-icon>
                  Verwijderen
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <slot name="action"/>
      </div>
    </template>

    <dd-main-table
        :hasSelect="true"
        @update-selected="(selected) => onUpdateSelected(selected)"
        @load-page="pageObject => onUpdatePagination(pageObject, category)"
        :loading="!(category.id.toString() in attachables)"
        :rows="attachables[category.id.toString()]"
        :paginator="paginations[category.id.toString()] && paginations[category.id.toString()].pagination"
        :selected-from-row="true"
        :skeletonRowLength="category.attachable_count ? category.attachable_count.data.count : 5"
        :headers="tableHeaders"
        :selected="selectedAttachablesForCategory(category)"
        action-width="120px"
        :loaded="loaded"
        data-dusk="main-table"
    >
      <template #actions="{ row }">
        <document-actions
            :category="category"
            :row="row"
        ></document-actions>
      </template>
    </dd-main-table>
    <form
        ref="zipForm"
        method="POST"
        action=""
        target="_blank"
        style="display: none;"
    >
      <div ref="zipIdsContainer"></div>
    </form>
  </dd-header-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import DocumentActions from "./DocumentActions.vue";
import attachableApi from "~/api/attachable";

export default {
  name: "AttachableCategoryCard",
  props: {
    category: Object,
  },
  computed: {
    ...mapState(`$_attachable_widget`, {
      tableHeaders: "tableHeaders",
      attachables: "attachables",
      paginations: "paginations",
      loaded: "loaded",
      activeCategoryId: "activeCategoryId",
    }),
    ...mapGetters(`$_attachable_widget`, {
      selectedFromActiveCategory: "selectedFromActiveCategory",
      selectedAttachablesForCategory: "selectedAttachablesForCategory",
    }),
    showMultipleActionButton() {
      return (this.activeCategoryId === this.category.id && this.selectedFromActiveCategory.length > 0);
    },
    selectedAttachableIds() {
      return this.selectedFromActiveCategory.map(attachable => attachable.id);
    }
  },
  components: {
    DocumentActions,
  },
  methods: {
    ...mapMutations(`$_attachable_widget`, {
      setSelectedAttachables: "SET_SELECTED_ATTACHABLES",
      setPaginations: "SET_PAGINATIONS",
      setShowCopyModal: "SET_SHOW_COPY_MODAL",
      setShowDeleteModal: "SET_SHOW_DELETE_MODAL",
      setActiveCategoryId: "SET_ACTIVE_CATEGORY_ID",
      setShowMoveModal: "SET_SHOW_MOVE_MODAL",
    }),
    ...mapActions(`$_attachable_widget`, {
      getAttachablesForCategory: "getAttachablesForCategory",
      deleteSelected: "deleteSelected",
    }),
    onMultipleDropdownClick(event) {
      this.setActiveCategoryId(this.category.id);
      event.stopPropagation();
    },
    onUpdateSelected(selected) {
      this.setActiveCategoryId(this.category.id);
      this.setSelectedAttachables({
        attachables: selected,
        id: this.category.id
      });
    },
    onUpdatePagination(pageObject, category) {
      this.setPaginations({
        categoryId: category.id.toString(),
        pagination: {
          ...this.paginations[category.id.toString()],
          ...pageObject
        }
      });
      this.getAttachablesForCategory(category);
    },
    onDeleteClick() {
      this.setActiveCategoryId(this.category.id);
      this.setShowDeleteModal(true);
    },
    onCopyClick() {
      this.setActiveCategoryId(this.category.id);
      this.setShowCopyModal(true);
    },
    onMoveClick() {
      this.setActiveCategoryId(this.category.id);
      this.setShowMoveModal(true);
    },
    onDownloadClick() {
      attachableApi
          .generateDownloadZipLink(this.selectedAttachableIds)
          .then(response => {
            this.$refs.zipForm.action = response.data.uri;
            // Empty the container
            this.$refs.zipIdsContainer.innerHTML = "";

            // Add hidden input for each id
            this.selectedAttachableIds.forEach(id => {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = "ids[]";
              input.value = id;
              this.$refs.zipIdsContainer.appendChild(input);
            });

            this.$refs.zipForm.submit();
          });
    },
    onCollapsed(collapsed, category) {
      if (collapsed) return;
      if (category.template) return;
      if (category.id in this.attachables) return;
      this.getAttachablesForCategory(category);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
